import { useFormikContext } from 'formik';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, IconButton, InputAdornment, Typography } from '@mui/material';
import RemoveIcon from '@mui/icons-material/Remove';
import { DefaultTextField } from '../../mui-overrides/Textfield';
import { Add } from '@mui/icons-material';
import { Asset } from '../../../models';

interface Props {
  disabled?: boolean;
}

export const HighlightsList: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();
  const formik = useFormikContext();

  const addClicked = () => {
    const currentHighlights = (formik.values as Asset).propertyDetails?.highlights || [];
    formik.setFieldValue('propertyDetails.highlights', [...currentHighlights, '']);
  };

  const removeClicked = (index: number) => {
    const currentHighlights = (formik.values as Asset).propertyDetails?.highlights || [];
    currentHighlights.splice(index, 1);
    formik.setFieldValue('propertyDetails.highlights', currentHighlights);
  };

  const currentHighlights = (formik.values as Asset).propertyDetails?.highlights || [];

  return (
    <>
      <Typography gutterBottom variant="h6">
        {t('dashboard.assets.addedit.main.propertyoverview.fields.highlights.label')}
      </Typography>
      {currentHighlights.map((item, index) => (
        <DefaultTextField
          inputProps={{
            maxLength: 100,
          }}
          label={`${index + 1}. ${t('dashboard.assets.addedit.main.propertyoverview.fields.highlights.item.label')}`}
          disabled={disabled}
          fieldName={`propertyDetails.highlights.${index}`}
          fieldList={['propertyDetails.highlights', index.toString()]}
          formik={formik}
          size="small"
          hideHelperText={true}
          muiInputProps={{
            endAdornment: (
              <InputAdornment
                position="end"
                onClick={() => {
                  removeClicked(index);
                }}
              >
                <IconButton edge="end">{<RemoveIcon />}</IconButton>
              </InputAdornment>
            ),
          }}
        />
      ))}
      <Button disabled={disabled} variant="contained" startIcon={<Add />} onClick={addClicked}>
        {t('dashboard.assets.addedit.main.rentalincome.button.addexpense')}
      </Button>
    </>
  );
};
